"use client"
import React, { useEffect, useState, useRef } from "react"
// import * as classes from "./projectSection.module.scss"
// import { isBrowser } from "../../../../utils/utils"
// import dynamic from "next/dynamic"
import { cn } from "@/utils/cn"
// const ReactPlayer = dynamic(() => import("react-player"), { ssr: false })
import styles from './ProjectSectionRichText.module.scss'
const ProjectSection = ({ projectSectionData, theme }) => {
	const { portfolioItemName, storyImageUrl, deepDescription } =
		projectSectionData

	const [expanded, setExpanded] = useState(false)
	const [showButton, setShowButton] = useState(false)
	const descRef = useRef(null)

	/* проверяем, нужна ли кнопка «Read more» */
	// useEffect(() => {
	// 	if (descRef.current) setShowButton(descRef.current.scrollHeight > 200)
	// }, [])
	useEffect(() => {
		const el = descRef.current;
		if (el) setShowButton(el.scrollHeight > 200);
	}, [deepDescription]);

	return (
		/* ↓ внутренняя обёртка — без внешних отступов (их даёт ваш wrapper) */
		<div className="flex flex-col gap-4 w-full md:flex-row md:gap-10">

			{/* изображение */}
			<div triggerOnce direction="left" className="w-full md:w-1/2">
				{/* <div className="w-full md:w-1/2 max-h-[340px] md:max-h-[380px]"> */}
				{/* <div className='xl:w-[588px] xl:h-[588px] flex justify-center items-center'> */}

				<img
					src={storyImageUrl}
					alt="project"
					// className="max-h-[340px] md:max-h-[358px] xl:max-h-[588px] object-contain "
					className=" md:max-h-[358px] xl:max-h-[588px] object-contain "
				// className="wв-full h-[340px] md:h-[380px] object-contain"
				/>
				{/* </div> */}
				{/* </div> */}
			</div>

			{/* текстовая часть */}
			<div
				triggerOnce
				direction="right"
				className="flex flex-col flex-nowrap justify-between w-full md:w-1/2"
			>
				<div className="flex flex-col items-start">
					<h3
						className="font-medium text-[24px] lg:text-[34px] leading-[100%] pb-4 xl:pb-6"
						style={{ color: theme.accentPrimaryFontColor }}
					>
						{portfolioItemName}
					</h3>
					<div
						ref={descRef}
						/* утилиты Tailwind по-прежнему можно комбинировать */
						className={cn(
							styles.richText,
							'text-sm xl:text-base leading-[125%]',
							expanded ? 'max-h-none' : 'max-h-[200px] overflow-hidden'
						)}
						/* динамические цвета остаются inline                     ↓  */
						style={{
							color: theme.accentSecondaryFontColor,
							fontFamily: theme.fontFamilySecondary,
							'--ps-link-color': theme.accentPrimaryFontColor,   // для <a>
						}}
						dangerouslySetInnerHTML={{ __html: deepDescription }}
					/>
					{/* <div
						ref={descRef}
						dangerouslySetInnerHTML={{ __html: deepDescription }}
						className={cn('text-sm xl:text-base leading-[125%] max-h-[200px] font-light ','prose prose-invert', expanded ? "max-h-none" : " overflow-hidden",
						)}
						style={{
							color: theme.accentSecondaryFontColor,
							fontFamily: theme.fontFamilySecondary,
						}}
					/> */}
					{showButton && (
						<button
							onClick={() => setExpanded(!expanded)}
							className="cursor-pointer mt-6 leading-[125%] xl:text-base xl:mt-10  text-sm font-medium pb-1 border-b-2 self-start"
							style={{
								fontFamily: theme.fontFamilyPrimary,
								color: theme.accentPrimaryFontColor,
								borderColor: theme.accentPrimaryFontColor,
							}}
						>
							{expanded ? "See Less" : "Read More"}
						</button>
					)}
				</div>

				{/* {showButton && (
					<button
						onClick={() => setExpanded(!expanded)}
						className="self-start pb-1 mt-4 font-medium border-b-2"
						style={{
							fontFamily: theme.fontFamilyPrimary,
							color: theme.accentPrimaryFontColor,
							borderColor: theme.accentPrimaryFontColor,
						}}
					>
						{expanded ? "See Less" : "Read More"}
					</button>
				)} */}
			</div>
		</div>
	)
}
// const ReactPlayer = dynamic(() => import("react-player"), { ssr: false })

// const ProjectSection = ({ projectSectionData, theme }) => {
//   const { portfolioItemName, storyImageUrl, deepDescription } =
//     projectSectionData
//   const [showButton, setShowButton] = useState(false)
//   const [buttonStatus, setButtonStatus] = useState(false)
//   const [videoError, setVideoError] = useState(false)

//   useEffect(() => {
//     if (isBrowser) {
//       const projectContainer = document.getElementById("projectSection")
//       const projectContainerHeight = projectContainer.clientHeight
//       setShowButton(projectContainerHeight > 200)
//     }
//   }, [])

//   return (
//     <>
//       <div
//         className={classes["projectSectionWrapper"]}
//         style={{
//           fontFamily: theme.fontFamilyPrimary,
//           alignItems: "flex-start",
//           height: "100%",
//         }}
//       >
//         <SlideWrapper triggerOnce direction={"left"} style={{ width: "100%" }}>
//           <div className={classes["leftSideSection"]}>
//             {!storyImageUrl && videoError ? (
//               // <span dangerouslySetInnerHTML={{ __html: videoLink }}></span>
//               <div className={classes["videoWrapper"]}>
//                 <ReactPlayer
//                   className={classes["react-player"]}
//                   width="100%"
//                   height="100%"
//                   url={videoLink}
//                   controls={true}
//                   onError={() => {
//                     setVideoError(true)
//                   }}
//                 />
//               </div>
//             ) : (
//               <img src={storyImageUrl} alt=" project"  className={classes["projectImage"]}/>
//             )}
//           </div>
//         </SlideWrapper>
//         <SlideWrapper
//           triggerOnce
//           direction={"right"}
//           style={{ height: buttonStatus ? "100%" : "400px" }}
//           className={classes["detailWrapper"]}
//         >
//             <div className={classes["descriptionWrapper"]}>
//               <div
//                 style={{ color: theme.accentPrimaryFontColor }}
//                 className={classes["heading"]}
//               >
//                 {portfolioItemName}

//               <div
//                 id="projectSection"
//                 dangerouslySetInnerHTML={{ __html: deepDescription }}
//                 style={{
//                   color: theme.accentSecondaryFontColor,
//                   fontFamily: theme.fontFamilySecondary,
//                 }}
//                 className={
//                   !showButton
//                     ? classes.desc
//                     : buttonStatus
//                     ? classes.desc
//                     : classes.slicedTextContainer
//                 }
//               ></div>
//             </div>

//             {showButton && (
//               <button
//                 className={classes["buttonReadMore"]}
//                 style={{
//                   fontFamily: theme.fontFamilyPrimary,
//                   color: theme.accentPrimaryFontColor,
//                   borderColor: theme.accentPrimaryFontColor,
//                 }}
//                 onClick={() => {
//                   setButtonStatus(!buttonStatus)
//                 }}
//               >
//                 {buttonStatus ? "See Less" : "Read More"}
//               </button>
//             )}

//             </div>
//         </SlideWrapper>
//       </div>
//     </>
//   )
// }

export default ProjectSection
